module.exports = __webpack_public_path__ + "img/complex-residence-medium.dee9b815.png";